
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-businesses",
      function () {
        return require("private-next-pages/for-businesses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-businesses"])
      });
    }
  